<template>

	<modal-dialog
		:modal-visible="visible"
		title="Share Records"
		:confirm-button-text="!shareLink ? 'Create Share Link' : 'Send'"
		:cancel-button-text="shareLink ? 'Done' : 'Cancel'"
		:working="isInProgress"
		v-on:closeModal="$emit('closeModal')"
		v-on:confirm="!shareLink ? saveGroupShare() : emailRecordGroup()">

		<h4>#1. Create Share Link</h4>

		<p>Create a share link with the following files?</p>

		<ul>
			<li v-for="record in selectedRecords">

				<span v-if="record && 'name' in record">
					{{ record.name }}
				</span>
				<span v-else-if="record && 'original_filename' in record">
					{{ record.original_filename }}
				</span>
				<span v-else>
					Unknown Record
				</span>
			</li>
		</ul>

		<div v-if="!shareLink">

			<field
				label="Description"
				col-class="stacked"
				v-model="description">
			</field>

		</div>

		<div v-else>

			<div class="d-flex">

				<div class="mr-1" style="flex-grow: 1">
					<input type="text" class="form-control" :value="shareLink" readonly>
				</div>

				<div style="align-self: flex-end;margin-bottom: 0.3rem">
					<button class="btn btn-light" type="button" title="Copy link to clipboard" v-on:click="copyToClipboard(shareLink,true)">
						<i class="fa fa-copy"></i>
					</button>
				</div>

			</div>

			<hr>

			<h4 class="mb-4">#2. Email Link (Optional)</h4>

			<!--
			<field
				v-if="contacts && contactOptions.length > 0" label="Contacts"
				col-class="col-sm-6 col-md-4"
				:params="{type:'select-multi',options: contactOptions}"
				v-model="contactRecipients">
			</field>
			-->

			<contact-search-select label="Contacts"
				col-class="col-md-4"
				:individuals-only="true"
				:select-multi="true"
				:parent-contact-id="parentContactId"
				v-model="contactRecipients">
			</contact-search-select>

			<field
				label="Employees"
				col-class="col-sm-6 col-md-4"
				:params="{type:'select-multi', options: employeeOptions}"
				v-model="employeeRecipients">
			</field>

			<div class="d-flex mt-4">
				<field
					label="Add an email" style="flex-grow: 1"
					class="mr-0"
					col-class="col-md-4"
					:params="{type:'email'}"
					v-model="email">
				</field>
				<div>
					<button class="btn btn-success" type="button" v-on:click="addEmailAddress">Add</button>
				</div>
			</div>

			<ul class="list-group mt-1 mb-2">
				<li v-for="(email,index) in emailRecipients" class="list-group-item list-group-item" v-on:click="removeEmailAddress(index)" style="cursor: pointer">
					<div class="d-flex justify-content-between align-items-center">
						<span>{{ email }}</span>
						<i class="fa fa-trash icon-button"></i>
					</div>
				</li>
			</ul>
		</div>

	</modal-dialog>

</template>


<script>

import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import ContactSearchSelect from "@/components/super_components/ContactSearchSelect"

export default {
	name: "ShareGroupModal",
	props: [
		'selectedRecords',
		'visible',
		'groupEndpoint',
		'contacts', // A list of external contacts with fields [name, email]
		'projectId',
		'serviceId',
		'contactId'
	],
	components: {
		ModalDialog,
		Field,
		ContactSearchSelect
	},
	data() {
		return {

			description: null,
			shareLink: null,
			email: "",
			groupId: null,
			isInProgress: false,

			emailRecipients: [],
			contactRecipients: [],
			employeeRecipients: []
		}
	},

	watch: {
		visible() {
			if (this.visible) {
				this.description = null
				this.shareLink = null
				this.email = ""
				this.groupId = null
				this.emailRecipients = []
				this.employeeRecipients = []
				this.contactRecipients = []
			}
		}
	},

	computed: {
		parentContactId() {
			if (this.contactId)
				return this.contactId
			else if (this.serviceId && this.$store.service && "customer_id" in this.$store.service)
				return this.$store.service.customer_id
			else if (this.projectId && this.$store.project && "customer_id" in this.$store.project)
				return this.$store.project.customer_id

			return false
		},
		employeeOptions() {
			return this.userOptions(false, false)
		},

		contactOptions() {

			let localContacts = []
			let contactIds = []       // for reference to avoid duplication

			this.contacts.forEach(contact => {
				if (!contactIds.includes(contact.id) && 'email' in contact && contact.email) {
					contactIds.push(contact.id)
					localContacts.push(contact)
				}
			})

			// Don't alter the original contacts objects
			localContacts = this.cloneObj(localContacts)

			return localContacts.map(contact => {
				contact.value = contact.id
				contact.text = contact.name + " (" + contact.email + ")"
				return contact
			})
		}
	},

	methods: {
		emailRecordGroup() {
			let vm = this

			this.isInProgress = true

			let payload = {
				id: this.groupId,
				recipients: this.contactRecipients,
				employeeRecipients: this.employeeRecipients,
				additional: this.emailRecipients.join(","),
			}

			this.postData(this.groupEndpoint+"/send",payload,true).then(response => {
				if (response.success) {
					vm.alertSuccess("Link has successfully sent!")
					vm.$emit('closeModal')
				}
				vm.isInProgress = false
			})
		},

		saveGroupShare() {
			let vm = this

			this.isInProgress = true

			let payload = {
				description: this.description,
			}

			let selected = this.cloneObj(this.selectedRecords.map(record => +record.id))

			if (this.groupEndpoint == 'FormShareGroup')
				payload.CompanyForm = selected
			else if (this.groupEndpoint == 'FileShareGroup')
				payload.UploadFile = selected

			if (this.projectId > 0)
				payload.job_id = this.projectId
			else if (this.serviceId > 0)
				payload.service_id = this.serviceId
			else if (this.contactId > 0)
				payload.contact_id = this.contactId

			this.postData(this.groupEndpoint+"/save",payload,true).then(response => {
				if (response.success) {

					if (this.groupEndpoint == 'FormShareGroup')
						vm.shareLink = this.apiRoot+"portal/forms/"+response.data.slug
					else if (this.groupEndpoint == 'FileShareGroup')
						vm.shareLink = this.apiRoot+"portal/sharing/package/"+response.data.slug

					vm.groupId = response.data.record_id
					vm.alertSuccess("Share link created")
				}

				vm.isInProgress = false
			})
		},

		addEmailAddress() {
			this.emailRecipients.push(this.email)
			this.email = ""
		},
		removeEmailAddress(index) {
			this.emailRecipients.splice(index,1)
		},
	},

	created() {
		if (!this.$store.users || !this.$store.users.length) {
			this.fetchUsers(false, false, false)
		}
	}
}
</script>

<style scoped>

</style>